import React from 'react'
import {Row,Col,Card} from 'antd'
import {Link} from 'react-router-dom'
import Timeago from '../Timeago'
import Image from './Image'
import Tags from './Tags'
//import * as CmsUtil from './CmsUtil'
import * as CacheUtil from '../util/CacheUtil'

export const SCROLL_Y = 'scrollY'

export default class ContentList extends React.Component {
  state = {}
  componentDidMount() {
    this.setup()
  }
  setup(timeout=0) {
    setTimeout(()=>{
      // get scroll position
      const scrollY = CacheUtil.get(SCROLL_Y)
      if (typeof(scrollY)==='number') {
        window.scrollTo(0,scrollY)
      } else {
        this.onScroll()
      }
      window.addEventListener('scroll', this.onScroll)
    },timeout)
  }
  componentWillUnmount() {
    window.removeEventListener('scroll', this.onScroll)
  }
  // FIXME: somehow scroll y position seems not that accurate, sometimes too off on coming back, it may caused by lazy loading of the card image
  onScroll() {
    const supportPageOffset = window.pageXOffset !== undefined;
    const isCSS1Compat = ((document.compatMode || '') === 'CSS1Compat');
    const scroll = {
       x: supportPageOffset ? window.pageXOffset : isCSS1Compat ? document.documentElement.scrollLeft : document.body.scrollLeft,
       y: supportPageOffset ? window.pageYOffset : isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop
    }
    if (typeof(scroll.y)==='number') {
      CacheUtil.set(SCROLL_Y, scroll.y)
    }
  }
  onTag=e=>{
    const {onTag} = this.props
    if (typeof(onTag)==='function') {
      onTag(e)
    }
  }
  render() {
    const {t,list} = this.props
    if (Array.isArray(list)&&list.length>0) {
      this.setup(10)
      return (
        <div className="content-list">
          <Row type="flex" justify="center" align="top">
            {
              list.map((e,i)=>{
                //const {_id,_slug,_type,name,lead,created,body,footer,tags,images,caption,notes,properties} = e
                const {_slug,_type,name,lead,created,tags,images} = e
                //const src = CmsUtil.srcOf(e)
                const to = `/${_type.toLowerCase()}/${_slug}`
                return (
                  <Col key={i} xs={24} sm={12} md={8} lg={6} className="mb-5">
                    <Link to={to}>
                      <Card
                        hoverable
                        //cover={<img alt={name} src={src} />}
                        cover={<Image {...images} />}
                        bordered={false}
                      >
                        <h3>{name}</h3>
                        <Timeago t={t} value={new Date(created)} className="mb-3" />
                        <Tags
                          className="mb-2"
                          type={'tag'}
                          values={tags}
                          //match={match}
                          onTag={this.onTag}
                          onClick={e=>{
                            e.preventDefault()
                            e.stopPropagation()
                          }}
                        />
                        <p>{lead}</p>
                        {/*<Card.Meta
                          title={name}
                          description={lead}
                        />*/}
                      </Card>
                    </Link>
                  </Col>
                )
              })
            }
          </Row>
        </div>
      )
    }
    return null
  }
}
